export const CHANGE_COLLECTION = '@changeCollection/filters';
export const CHANGE_PERIOD = '@changePeriod/filters';
export const CHANGE_WITH_DELIVERED_ORDERS = '@changeWithDeliveredOrders/filters';